export const RequestBoardColumnContentState = {
  Cards: 'cards',
  Empty: 'empty',
  Error: 'error',
  Loading: 'loading',
}
